module.exports = __webpack_public_path__ + "img/8-1.86c738e7.jpg";